import { Button, Icon } from "@/components"
import { useStyles } from "@/pages/campaign-form/components/campaigns/writeALetter/Message.styles"
import { SingleColumnLayout } from "@/pages/campaign-form/components/layouts/SingleColumnLayout/SingleColumnLayout"
import { MessageGroupSection } from "@/pages/campaign-form/components/sections/message/MessageGroupSection/MessageGroupSection"
import { createOfficialsSafedSearch } from "@/pages/campaign-form/helpers"
import { CampaignFormValues } from "@/pages/campaign-form/types"
import { Accordion } from "@mantine/core"
import React from "react"
import { useFieldArray, useFormContext } from "react-hook-form"
import { isInternational } from "shared/imports/regionConstants"

const { DraftOptions, MessageVariationsType } = DjangIO.app.grassroots.campaign.types

export const MAX_MESSAGES = 6

interface MessageProps {
    namePrefix?: string
}

export const Message = ({ namePrefix = null }: MessageProps) => {
    const { classes } = useStyles()
    const formContext = useFormContext<CampaignFormValues>()
    const messageGroupsName = namePrefix ? `${namePrefix}.message_groups` : "message_groups"
    const fieldArray = useFieldArray({
        name: messageGroupsName,
        control: formContext.control,
    }) as any
    const { fields, append } = fieldArray

    const filteredFields = fields.filter(({ archived }) => archived === false)

    const [openedItem, setOpenedItem] = React.useState<string>("1")

    return (
        <SingleColumnLayout>
            <Accordion variant="separated" defaultValue={openedItem} value={openedItem} onChange={setOpenedItem}>
                {fields.map(
                    (message, index) =>
                        message.archived === false && (
                            <MessageGroupSection
                                key={`${message.id}|${message.index}`}
                                index={index}
                                setOpenedItem={setOpenedItem}
                                message={message}
                                fieldArray={fieldArray}
                                prefix={namePrefix}
                            />
                        ),
                )}
            </Accordion>
            {fields.length < MAX_MESSAGES && (
                <Button
                    className={classes.addMessageButton}
                    leftIcon={<Icon icon="plus" />}
                    onClick={() => {
                        append({
                            name: `Message ${filteredFields.length + 1}`,
                            index: (filteredFields[filteredFields.length - 1]?.index ?? 0) + 1,
                            archived: false,
                            custom_email_targets: [],
                            uses_default_member_list: !isInternational,
                            standard_options_search: null,
                            advocate_editing_permission: DraftOptions.can_edit.value,
                            message_variations_type: MessageVariationsType.none.value,
                            message_variations: [
                                {
                                    subject: "",
                                    content: "",
                                    archived: false,
                                    fixed_pre_content: "",
                                    fixed_post_content: "",
                                    index: 0,
                                    ai_generation_type: null,
                                },
                            ],
                            has_custom_email_targets: false,
                        })
                        setOpenedItem(`${fields.length + 1}`)
                        createOfficialsSafedSearch(formContext, filteredFields.length, namePrefix)
                    }}
                    variant="tonal"
                >
                    Add message
                </Button>
            )}
        </SingleColumnLayout>
    )
}
